import { fetchMainApi } from '@/api';

export const loginUser = async (dto) => {
  const values = {
    email: dto.username,
    password: dto.password,
  };
  
  const response = await fetchMainApi('POST', '/users/login', { body: JSON.stringify(values) }, 'application/json', false);

  return { data: response.data || response };
};

export const registerUser = async (dto) => {
  const response = await fetchMainApi('POST', '/users/register', { body: JSON.stringify(dto) }, 'application/json', false);

  return { data: response.data || response };
};

export const logoutUser = async () => {
  return await fetchMainApi('POST', '/users/logout');
};

export const forgotPassword = async (email) => {
  return await fetchMainApi('POST', '/password/email', { body: JSON.stringify({ email }) });
};

export const resetPassword = async (password, email, token) => {
  return await fetchMainApi("POST", "/password/reset", {
    body: JSON.stringify({
      token,
      email,
      password,
      password_confirmation: password,
    })
  });
};
export const signupInvite  = async (invite_token, password) => {
  return await fetchMainApi("POST", "/users/invite", {
    body: JSON.stringify({
      password,
      password_confirmation: password,
      invite_token,
    })
  });
};